'use strict';

var ChartLengthOfStayLegendDirective = function ChartLengthOfStayLegendDirective() {
  return {
    restrict: 'E',
    template: require('../templates/chart-length-of-stay-legend.html'),
    controller: 'ChartLengthOfStayLegendController',
    scope: {
      selectedOriginalService: '='
    },
    link: function link(scope) {
      scope.$watch('selectedOriginalService', function (newSelectedService) {
        if (!newSelectedService) {
          return;
        }
        scope.isTOD = newSelectedService.isTOD;
        scope.serviceChartTitle = scope.displayServiceIdToFlights(newSelectedService.displayServiceId);
      });
    }
  };
};
ChartLengthOfStayLegendDirective.$inject = [];
module.exports = ChartLengthOfStayLegendDirective;